import { Box, BoxProps } from '@chakra-ui/react';

import { Markdown } from '~/components/markdown';

import { ContentContainer } from './container';

export function Footnote({ text, boxProps }: { text: string; boxProps?: BoxProps }) {
  return (
    <Box as='section' backgroundColor='white' padding='24px 0px' {...boxProps}>
      <ContentContainer>
        <Box
          width='100%'
          sx={{
            '& > *,.chakra-text,.chakra-link': {
              fontSize: '0.75rem',
            },
            'ul,ol': {
              padding: '0px',
              margin: '0px',
            },
          }}
        >
          <Markdown markdownText={text} />
        </Box>
      </ContentContainer>
    </Box>
  );
}
